<template>
    <common-panel
            v-model="value"
            :image="image"
            :is-read-only="readOnly"
            :width-style="widthStyle"
            :related-url="relatedUrl"
            :validation-lists="validationLists"
            :translate-obj="translateObj"
            :element-author-display="elementAuthorDisplay"
            @close="closePanel"
            @changeTranslate="changeTranslate"
    >

        <template slot="t-img">
            <v-list-item-avatar>
                <img :src="value.imgSrc">
            </v-list-item-avatar>
        </template>

        <template slot="t-edit-user">
            <div
                    v-if="newEditUserImg.length > 0 && readOnly"
                    style="text-align:center"
            >
                <v-chip
                        small
                        color="orange"
                        text-color="white"
                        style="font-weight:bold">
                    <v-avatar left>
                        <v-icon>mdi-lead-pencil</v-icon>
                    </v-avatar>
                    {{newEditUserImg[0].name}} is now editing...
                </v-chip>
            </div>
        </template>

        <template slot="md-name-panel-translate">
            <div></div>
        </template>

        <template slot="md-description">
            <div></div>
        </template>
    </common-panel>

</template>


<script>
    import CommonPanel from "./CommonPanel";
    import EventStormingModelPanel from "../EventStormingModelPanel";

    export default {
        mixins: [EventStormingModelPanel],
        name: 'text-panel',
        components: {
            CommonPanel
        },
        data() {
            return {

            }
        },
        created: function () {
            this.panelInit()
        },
        methods: {
            panelInit(){
                var me = this
                // Text

                // Common
                me.$super(EventStormingModelPanel).panelInit()
            },
        }
    }
</script>
